import React from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import { appTheme } from "./theme";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import NavMenu from "./components/NavigationBar";
import { APP_HEADER_OFFSET } from "./constants/layout";
import ScrollToTop from "./components/ScrollToTop";
import AppRouter from "./router/Router";
import { AuthProvider, useAuth } from "./firebase/AuthProvider";
import { PermissionProvider } from "./firebase/PermissionProvider";
import { MasterDataProvider } from "./providers/MasterDataProvider";
import { NotificationProvider } from "./providers/NotificationProvider";
import { ConfirmProvider } from "./providers/ConfirmProvider";

const Layout = () => {
  const { user } = useAuth();
  const location = useLocation();

  // ログインページのときは NavMenu を表示しない
  const hideNav = location.pathname === "/login";

  return (
    <div className="App" style={{ overflowX: 'hidden' }}>
      {!hideNav && user && <NavMenu />}
      <div style={{
        // ヘッダー (Toolbar minHeight 30px) の実高に合わせた余白。
        // 50px では約 20px の空きが生じ、一覧の表示領域を圧迫していた
        marginTop: !hideNav && user ? `${APP_HEADER_OFFSET}px` : '0',
        width: '100%'
      }}>
        <AppRouter />
      </div>
    </div>
  );
};

export default function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <AuthProvider>
        <PermissionProvider>
          <MasterDataProvider>
            <NotificationProvider>
              <ConfirmProvider>
                <Router>
                  <ScrollToTop />
                  <Layout />
                </Router>
              </ConfirmProvider>
            </NotificationProvider>
          </MasterDataProvider>
        </PermissionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
